import styled from "styled-components";

export const CuerpoCalendario = styled.div`
  font-family: 'Montserrat', sans-serif;
  background-color: #fff;
  padding: 1rem;
  display: flex;
  justify-content: center;
`;

export const ContenedorCalendario = styled.div`
  border: 1px solid #dcdcdc;
  border-radius: 10px;
  padding: 1rem;
  width: 90%;
  max-width: 900px;
  position: relative;
`;

export const DiasSemana = styled.div`
  display: flex;
  justify-content: space-around;
  margin-bottom: 1rem;
`;

export const Dia = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  border-radius: 50%;
  padding: 0.5rem;
  width: 45px;
  height: 45px;
  background-color: ${(props) => (props.seleccionado ? "#e1b12c" : "transparent")};
  color: ${(props) => (props.seleccionado ? "#fff" : "#000")};
  font-weight: ${(props) => (props.seleccionado ? "bold" : "normal")};
`;

export const HoraFila = styled.div`
  border-top: 1px solid #ccc;
  padding: 0.6rem 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Evento = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

export const NombrePaciente = styled.span`
  font-weight: 500;
`;

export const Precio = styled.span`
  font-weight: bold;
  color: #333;
`;

export const AccionIcono = styled.span`
  margin-left: 0.4rem;
  cursor: pointer;
  color: ${(props) => props.color};
`;

export const VistaBotones = styled.div`
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
  
  button {
    border: none;
    background-color: #f39c12;
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;
  }
`;

export const Navegacion = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-top: 1rem;

  button {
    border: none;
    background: none;
    cursor: pointer;
    font-size: 1rem;
  }
`;

export const BotonHoy = styled.button`
  background-color: #f39c12;
  color: white;
  padding: 0.5rem 1.2rem;
  border-radius: 5px;
  border: none;
  font-weight: bold;
  cursor: pointer;
`;

export const BotonAgregar = styled.button`
  position: absolute;
  right: -50px;
  bottom: 0;
  background: white;
  border: 2px solid #f39c12;
  color: #f39c12;
  font-size: 1.5rem;
  border-radius: 50%;
  width: 45px;
  height: 45px;
  cursor: pointer;
`;

/* --- Modal --- */
export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  background: white;
  padding: 2rem;
  border-radius: 10px;
  width: 400px;

  form {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  input {
    padding: 0.4rem;
    border: 1px solid #ccc;
    border-radius: 5px;
  }

  button {
    margin-right: 0.5rem;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 5px;
    cursor: pointer;
  }

  button[type="submit"] {
    background: #f39c12;
    color: white;
    font-weight: bold;
  }

  button[type="button"] {
    background: #ccc;
    color: black;
  }
`;
